<template>
  <section class="guided-mode__card">
    <GuidedModeVisual
      :media="media"
      :fallback-icon="mdiCalendarMonthOutline"
      :size="mediaSize"
      :interactive="mediaInteractive"
      @toggle-size="$emit('toggle-size')"
    />
    <p class="guided-mode__prompt">{{ prompt }}</p>
    <output v-if="calculated" class="guided-mode-date" aria-live="polite">{{ formattedDate }}</output>
    <label v-else class="guided-mode-date">
      <span>{{ $t('app.assessment_mode.guided.date.select_label') }}</span>
      <input :value="value" type="date" :min="min" :max="max" @input="$emit('date-changed', $event.target.value)" @change="$emit('entry-complete')">
      <small v-if="invalid">{{ $t('app.assessment_mode.guided.date.range_error', { min: formatDate(min), max: formatDate(max) }) }}</small>
    </label>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { mdiCalendarMonthOutline } from '@mdi/js'
import GuidedModeVisual from './GuidedModeVisual.vue'
import type { GuidedModeMedia } from '../types/guided-mode.types'

export default defineComponent({
  name: 'GuidedModeDate',
  components: { GuidedModeVisual },
  props: {
    calculated: Boolean,
    prompt: { type: String, required: true },
    value: { type: String, default: '' },
    min: { type: String, default: '' },
    max: { type: String, default: '' },
    invalid: { type: Boolean, default: false },
    media: { type: Object as PropType<GuidedModeMedia | null>, default: null },
    mediaSize: { type: String, default: 'default' },
    mediaInteractive: { type: Boolean, default: false },
  },
  emits: ['date-changed', 'toggle-size', 'entry-complete'],
  data: () => ({ mdiCalendarMonthOutline }),
  computed: {
    formattedDate(): string {
      return this.calculated ? this.formatDate(this.value) : ''
    },
  },
  methods: {
    formatDate(value: string): string {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return ''
      // This is a calendar date, not a UTC instant: preserve its day in the user's timezone.
      const date = new Date(`${value}T00:00:00`)
      return Number.isFinite(date.getTime()) ? this.$d(date, 'short') : ''
    },
  },
})
</script>
